import React, { memo } from 'react'

import { Box, CircularProgress, Typography } from '@mui/material'
import { colors } from '@theme/variables'

const SpinnerWithLabel = ({ value }: { value: number }) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', fontSize: '11px' }}>
      <CircularProgress size="30px" />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="body2" fontSize="inherit" component="div" sx={{ color: colors.bodyText }}>{`${Math.round(
          value,
        )}%`}</Typography>
      </Box>
    </Box>
  )
}

export default memo(SpinnerWithLabel)
